import React from 'react';
import api from './../../../services/api';
import { user_token } from '../../../services/Auth';

//import da API
import { organizer } from './../../../services/api';
let apiOrganizer = new organizer();

var token = localStorage.getItem(user_token);

export default class GetProfessional extends React.Component {
  state = {
    exam_possible_date: []
  }

  componentDidMount() {
    //api.get(`/professional/${this.props.professional_id}`, {headers: {'x-access-token': token}})
    apiOrganizer.getProfessional(this.props.professional_id)
      .then(res => {
        const exam_possible_date = res.data;
        this.setState({ exam_possible_date });
      })
  }

  render() {
    return (
      <ul>
        { this.state.exam_possible_date.map(details => 
        <>
                <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Profissional da Saúde: </p><p>{details.name}</p>
                <p id="RI-Title-Cadastro-Paciente" >Data de nascimento do(a) Profissional da Saúde: </p><p>{details.birth}</p>
                <p id="RI-Title-Cadastro-Paciente" >Genêro Profissional do(a) Profissional da Saúde: </p><p>{details.gender}</p>
                <p id="RI-Title-Cadastro-Paciente" >CPF do(a) Profissional da Saúde: </p><p>{details.cpf}</p>
                <p id="RI-Title-Cadastro-Paciente" >Email Profissional do(a) Profissional da Saúde: </p><p>{details.email}</p>
                <p id="RI-Title-Cadastro-Paciente" >Telefone Profissional do(a) Profissional da Saúde: </p><p>{details.phone}</p>
                <p id="RI-Title-Cadastro-Paciente" >Número do Conselho Profissional do(a) Profissional da Saúde: </p><p>{details.crm}</p>
                <p id="RI-Title-Cadastro-Paciente" >Área do(a) Profissional da Saúde: </p><p>{details.occupation_area}</p>
                <p id="RI-Title-Cadastro-Paciente" >Especialidade do(a) Profissional da Saúde: </p><p>{details.medical_specialty}</p>
                <p id="RI-Title-Cadastro-Paciente" >Especialidade na áre da Sáude: </p><p>{details.health_specialty}</p>
                <p id="RI-Title-Cadastro-Paciente" >Tipo de atendimento do(a) Profissional da Saúde: </p><p>{details.voluntary_type}</p>
                        
        </>)}
      </ul>
    )
  }
}